import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=11010c1a&scoped=true"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"
import style0 from "./reset_password.vue?vue&type=style&index=0&id=11010c1a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11010c1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11010c1a')) {
      api.createRecord('11010c1a', component.options)
    } else {
      api.reload('11010c1a', component.options)
    }
    module.hot.accept("./reset_password.vue?vue&type=template&id=11010c1a&scoped=true", function () {
      api.rerender('11010c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_terminal_management/form/components/reset_password/reset_password.vue"
export default component.exports